<template>
  <div
    class="modal fade"
    id="locationManagementEditModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>

          <h4 class="modal-title">
            <b>{{ dialogTitle }}</b>
          </h4>

          <div v-if="locationData.LocationId">
            <label class="control-label"
              >ID: {{ locationData.LocationId }}</label
            >
            <i
              id="showLocationHistoryInfoIcon"
              class="material-icons md-24"
              @click="showLocationHistory()"
              >history</i
            >
            <b-tooltip
              ref="tooltip"
              target="showLocationHistoryInfoIcon"
              :delay="globals.tooltipDelay"
              >{{ lang.L0090 }}</b-tooltip
            >
          </div>
        </div>
        <div class="modal-body">
          <div
            class="panel-group"
            id="accordion"
            role="tablist"
            aria-multiselectable="true"
          >
            <div class="panel panel-default">
              <!-- Accordion entry 1 -->
              <div
                class="panel-heading"
                role="button"
                id="headingGeneral"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapseGeneral"
                aria-expanded="true"
                aria-controls="collapseGeneral"
              >
                <h4 class="panel-title">
                  <a class="collapsed">{{ lang.L0021 }}</a>
                </h4>
              </div>
              <div
                id="collapseGeneral"
                class="panel-collapse collapse in"
                role="tabpanel"
                aria-labelledby="headingGeneral"
              >
                <div class="panel-body">
                  <div
                    class="form-group"
                    v-if="
                      !feature.isAudiTarget ||
                      !feature.isEnabled('audi_importers')
                    "
                  >
                    <label for="inputClient" class="col-md-2 control-label"
                      >{{ lang.L0022 }}*</label
                    >
                    <div class="col-md-10">
                      <select2
                        class="form-control"
                        id="inputClient"
                        name="inputClient"
                        v-model="locationData.ClientId"
                        :placeholder="lang.L0023"
                        :disabled="selectedLocation > 0"
                        @change="getLocationProperties(locationData.ClientId)"
                        required
                      >
                        <option></option>
                        <option
                          v-for="client in clientList"
                          :key="client.ClientId"
                          :value="client.ClientId"
                        >
                          {{ client.ClientName }}
                        </option>
                      </select2>
                      <span
                        v-show="inputHasError('inputClient')"
                        class="help-block error text-danger"
                        >{{ lang.L0078 }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group" v-else>
                    <label
                      for="inputLocationImporter"
                      class="col-md-2 control-label"
                      >{{ lang.L0088 }}*</label
                    >
                    <div class="col-md-10">
                      <select2
                        class="form-control"
                        id="inputLocationImporter"
                        name="inputLocationImporter"
                        v-model="locationData.ImporterGuid"
                        :placeholder="lang.L0023"
                        required
                      >
                        <option></option>
                        <option
                          v-for="importer in importerList"
                          :key="importer.ImporterGuid"
                          :value="importer.ImporterGuid"
                        >
                          {{ importer.ImporterName }}
                        </option>
                      </select2>
                      <span
                        v-show="inputHasError('inputLocationImporter')"
                        class="help-block error text-danger"
                        >{{ lang.L0078 }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputStoreId" class="col-md-2 control-label"
                      >{{ lang.L0024 }}*</label
                    >
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputStoreId"
                        name="inputStoreId"
                        v-model="locationData.LocationStoreId"
                        @keyup="validateInput('inputStoreId')"
                        required
                      />
                      <span
                        v-show="inputHasError('inputStoreId')"
                        class="help-block error text-danger"
                        >{{ lang.L0078 }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="inputLocationName"
                      class="col-md-2 control-label"
                      >{{ lang.L0025 }}*</label
                    >
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputLocationName"
                        name="inputLocationName"
                        v-model="locationData.LocationName"
                        @keyup="validateInput('inputLocationName')"
                        maxlength="50"
                        required
                      />
                      <span
                        v-show="inputHasError('inputLocationName')"
                        class="help-block error text-danger"
                        >{{ lang.L0078 }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputAddress" class="col-md-2 control-label">{{
                      lang.L0026
                    }}</label>
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputAddress"
                        v-model="locationData.LocationAddress"
                        maxlength="150"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputAddress2" class="col-md-2 control-label">{{
                      lang.L0027
                    }}</label>
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputAddress2"
                        v-model="locationData.LocationAddress2"
                        maxlength="150"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputDistrict" class="col-md-2 control-label">{{
                      lang.L0028
                    }}</label>
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputDistrict"
                        v-model="locationData.LocationCounty"
                        maxlength="250"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputCity" class="col-md-2 control-label">{{
                      lang.L0029
                    }}</label>
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputCity"
                        v-model="locationData.LocationCity"
                        maxlength="50"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputCountry" class="col-md-2 control-label">{{
                      lang.L0030
                    }}</label>
                    <div class="col-md-10">
                      <select2
                        class="form-control"
                        v-model="locationData.LocationCountry"
                        @change="changedCountry(locationData.LocationCountry)"
                        :placeholder="lang.L0023"
                        :allowClear="true"
                      >
                        <option></option>
                        <option
                          v-for="(country, ISOCode) in globals.countryList"
                          :key="ISOCode"
                          :value="ISOCode"
                        >
                          {{ country }}
                        </option>
                      </select2>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputRegion" class="col-md-2 control-label">{{
                      lang.L0031
                    }}</label>
                    <div class="col-md-10">
                      <select2
                        class="form-control"
                        v-model="locationData.LocationState_Region"
                        ref="regionSelect"
                        :disabled="currentRegions.length < 1"
                        :placeholder="lang.L0023"
                        :allowClear="true"
                      >
                        <option></option>
                        <option
                          v-for="region in currentRegions"
                          :key="region.Region"
                          :value="region.Region"
                        >
                          {{ region.RegionName }}
                        </option>
                      </select2>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputTimeZone" class="col-md-2 control-label">{{
                      lang.L0032
                    }}</label>
                    <div class="col-md-10">
                      <select2
                        class="form-control"
                        v-model="locationData.LocationTimeZoneId"
                        ref="timeZoneSelect"
                        :disabled="currentTimeZones.length < 1"
                        :placeholder="lang.L0023"
                        :allowClear="true"
                      >
                        <option></option>
                        <option
                          v-for="tz in currentTimeZones"
                          :key="tz.TimeZoneId"
                          :value="tz.TimeZoneId"
                        >
                          {{ tz.TimeZoneName }}
                        </option>
                      </select2>
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="inputExportCountryCode"
                      class="col-md-2 control-label"
                      >{{ lang.L0084 }}</label
                    >
                    <div class="col-md-10">
                      <select2
                        class="form-control"
                        id="inputExportCountryCode"
                        v-model="locationData.LocationExportDefaultCountryCode"
                        @change="changedExportCountryCode()"
                        :placeholder="lang.L0023"
                        :allowClear="true"
                      >
                        <option></option>
                        <option
                          v-for="(country, ISOCode) in globals.countryList"
                          :key="ISOCode"
                          :value="ISOCode"
                        >
                          {{ country }}
                        </option>
                      </select2>
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="inputExportLanguageCode"
                      class="col-md-2 control-label"
                      >{{ lang.L0085 }}</label
                    >
                    <div class="col-md-10">
                      <select2
                        class="form-control"
                        id="inputExportLanguageCode"
                        ref="exportLanguageSelect"
                        v-model="locationData.LocationExportDefaultLanguageCode"
                        :disabled="currentExportLanguages.length < 1"
                        :placeholder="lang.L0023"
                        :allowClear="true"
                      >
                        <option></option>
                        <option
                          v-for="language in currentExportLanguages"
                          :key="language.LanguageCode"
                          :value="language.LanguageCode"
                        >
                          {{ language.LanguageName }}
                        </option>
                      </select2>
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="inputPostalCode"
                      class="col-md-2 control-label"
                      >{{ lang.L0033 }}</label
                    >
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputPostalCode"
                        v-model="locationData.LocationPostalCode"
                        maxlength="12"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputPhone" class="col-md-2 control-label">{{
                      lang.L0034
                    }}</label>
                    <div class="col-md-10">
                      <input
                        type="tel"
                        class="form-control"
                        id="inputPhone"
                        name="inputPhone"
                        v-model="locationData.LocationPhone"
                        @keyup="validateInput('inputPhone')"
                      />
                      <span
                        v-show="inputHasError('inputPhone')"
                        class="help-block error text-danger"
                        >{{ lang.L0079 }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputFax" class="col-md-2 control-label">{{
                      lang.L0035
                    }}</label>
                    <div class="col-md-10">
                      <input
                        type="tel"
                        class="form-control"
                        id="inputFax"
                        name="inputFax"
                        v-model="locationData.LocationFax"
                        @keyup="validateInput('inputFax')"
                      />
                      <span
                        v-show="inputHasError('inputFax')"
                        class="help-block error text-danger"
                        >{{ lang.L0080 }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputPhotoURL" class="col-md-2 control-label">{{
                      lang.L0037
                    }}</label>
                    <div class="col-md-10">
                      <input
                        type="url"
                        class="form-control"
                        id="inputPhotoURL"
                        name="inputPhotoURL"
                        v-model="locationData.LocationPhotoURL"
                        @keyup="validateInput('inputPhotoURL')"
                      />
                      <span
                        v-show="inputHasError('inputPhotoURL')"
                        class="help-block error text-danger"
                        >{{ lang.L0081 }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="inputExportMail"
                      class="col-md-2 control-label"
                      >{{ lang.L0038 }}</label
                    >
                    <div class="col-md-10">
                      <input
                        type="email"
                        class="form-control"
                        id="inputExportMail"
                        name="inputExportMail"
                        v-model="locationData.LocationExportEmail"
                        @keyup="validateInput('inputExportMail')"
                        multiple
                      />
                      <span
                        v-show="inputHasError('inputExportMail')"
                        class="help-block error text-danger"
                        >{{ lang.L0082 }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="inputExportMailName"
                      class="col-md-2 control-label"
                      >{{ lang.L0039 }}</label
                    >
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputExportMailName"
                        v-model="locationData.LocationExportEmailName"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputStatus" class="col-md-2 control-label">{{
                      lang.L0040
                    }}</label>
                    <div class="col-md-10">
                      <select
                        class="form-control"
                        v-model="locationData.LocationStatusId"
                        @change="$forceUpdate()"
                      >
                        <option
                          v-for="(status, key) in locationStatusList"
                          :key="key"
                          :value="key"
                        >
                          {{ status }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputLatitude" class="col-md-2 control-label">{{
                      lang.L0044
                    }}</label>
                    <div class="col-md-10">
                      <input
                        type="number"
                        step="any"
                        min="-90"
                        max="90"
                        class="form-control"
                        id="inputLatitude"
                        v-model="locationData.LocationLatitude"
                        @input="validateInput('inputLatitude')"
                      />
                      <span
                        v-show="inputHasError('inputLatitude')"
                        class="help-block error text-danger"
                        >{{ lang.L0083 }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="inputLongitude"
                      class="col-md-2 control-label"
                      >{{ lang.L0045 }}</label
                    >
                    <div class="col-md-10">
                      <input
                        type="number"
                        step="any"
                        min="-180"
                        max="180"
                        class="form-control"
                        id="inputLongitude"
                        v-model="locationData.LocationLongitude"
                        @input="validateInput('inputLongitude')"
                      />
                      <span
                        v-show="inputHasError('inputLongitude')"
                        class="help-block error text-danger"
                        >{{ lang.L0083 }}</span
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="inputGeocodeSource"
                      class="col-md-2 control-label"
                      >{{ lang.L0046 }}</label
                    >
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputGeocodeSource"
                        v-model="locationData.LocationGeocodeSource"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Accordion entry 2 -->
              <div
                class="panel-heading"
                role="button"
                id="headingRemarks"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapseRemarks"
                aria-expanded="false"
                aria-controls="collapseRemarks"
              >
                <h4 class="panel-title">
                  <a class="collapsed">{{ lang.L0052 }}</a>
                </h4>
              </div>
              <div
                id="collapseRemarks"
                class="panel-collapse collapse"
                role="tabpanel"
                aria-labelledby="headingRemarks"
              >
                <div class="panel-body">
                  <div class="form-group">
                    <label
                      for="inputAdditionalInfo"
                      class="col-md-2 control-label"
                      >{{ lang.L0053 }}</label
                    >
                    <div class="col-md-10">
                      <textarea
                        class="form-control"
                        rows="6"
                        maxlength="2000"
                        id="inputAdditionalInfo"
                        v-model="locationData.LocationAdditionalInfo"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Accordion entry 3 -->
              <div
                class="panel-heading"
                role="button"
                id="headingCustProp"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapseCustProp"
                aria-expanded="false"
                aria-controls="collapseCustProp"
                v-show="locationData.CustomProperties"
              >
                <h4 class="panel-title">
                  <a class="collapsed">{{ lang.L0054 }}</a>
                </h4>
              </div>
              <div
                id="collapseCustProp"
                class="panel-collapse collapse"
                role="tabpanel"
                aria-labelledby="headingCustProp"
                v-show="locationData.CustomProperties"
              >
                <div class="panel-body">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th style="width: 40%" class="text-center">
                          {{ lang.L0055 }}
                        </th>
                        <th style="width: 60%" class="text-center">
                          {{ lang.L0056 }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="property in locationData.CustomProperties"
                        :key="property.ID"
                      >
                        <td>{{ property.Name }}</td>
                        <td class="nopadding">
                          <div class="form-group nopadding">
                            <textarea
                              rows="1"
                              maxlength="1000"
                              type="text"
                              class="form-control text-center textarea-custom-properties autoExpand"
                              v-model="property.Value"
                            ></textarea>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <b-alert
            variant="danger"
            dismissible
            :show="showAlert"
            @dismissed="showAlert = false"
            >{{ lang.L0057 }}</b-alert
          >
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-default"
            data-dismiss="modal"
          >
            {{ lang.L0058 }}
          </button>
          <button
            type="button"
            id="location-management-dialog-save-button"
            class="btn btn-raised dialog-btn-primary"
            @click="validateBeforeSubmit('locationManagementEditModal')"
            :disabled="
              !globals.isAccessAllowed('LoopOp_Locations_Update') &&
              selectedLocation > 0
            "
          >
            {{ lang.L0059 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "LocationManagementEditModal",
  components: {
    Select2,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    selectedLocation: {
      type: Number,
      default: -1,
    },
    lang: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogTitle: "",
      locationData: {},
      currentRegions: [],
      currentTimeZones: [],
      currentExportLanguages: [],
      showAlert: false,
      timeZones: [],
      locationStatusList: [],
      regionList: [],
      clientList: [],
      importerList: [],
      countryLanguages: [],
      invalidInputIds: [],
    };
  },
  watch: {
    "globals.selectedLanguage"() {
      this.getLocationStatusList();
      this.globals.getCountryList();
    },
    showModal(newVal) {
      if (newVal) this.initLocationData();
    },
  },
  mounted() {
    this.getSelectData();

    $("#locationManagementEditModal").on("hidden.bs.modal", (e) =>
      this.$emit("modalClosed")
    );
  },
  methods: {
    openModal() {
      $("#locationManagementEditModal").modal("show");
    },
    closeModal() {
      $("#locationManagementEditModal").modal("hide");
    },
    correctTextareaHeight() {
      this.$nextTick(() => {
        let textareas = document.getElementsByClassName("autoExpand");
        for (let i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },
    validateInput(id) {
      let result = $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error");
        let idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1);
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id);
      }
      return result;
    },
    inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },
    validateBeforeSubmit(dialogId) {
      let result = true;

      let elements = $("#" + dialogId).find(":input");
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          result = this.validateInput(elements[i].id) && result;
      }

      if (dialogId === "locationManagementEditModal") {
        this.showAlert = !result;
        if (!result) return;
        this.saveLocationData();
      }
    },
    resetValidationErrors(dialogId) {
      let elements = $("#" + dialogId).find(":input");
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    showLocationHistory() {
      let config = {
        type: "Location",
        guid: this.locationData.LocationGuid,
        id: this.locationData.LocationId,
      };
      this.globals.$emit("showElementHistory", config);
    },
    changedCountry(country) {
      let regionObj = [{ Regions: [] }];
      let tzObj = [{ TimeZones: [] }];

      if (this.regionList) {
        if (country) {
          regionObj = this.regionList.filter(
            (region) =>
              region.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0
          );
        }
      }

      if (this.timeZones) {
        if (country) {
          tzObj = this.timeZones.filter(
            (tz) => tz.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0
          );
        }
      }

      if (regionObj.length === 0) this.currentRegions = [];
      else this.currentRegions = regionObj[0].Regions;

      if (tzObj.length === 0) this.currentTimeZones = [];
      else this.currentTimeZones = tzObj[0].TimeZones;

      let idx = this.currentRegions
        .map((e) => e.Region)
        .indexOf(this.locationData.LocationState_Region);
      if (idx < 0) delete this.locationData.LocationState_Region;

      idx = this.currentTimeZones
        .map((e) => e.TimeZoneId)
        .indexOf(this.locationData.LocationTimeZoneId);
      if (idx < 0) delete this.locationData.LocationTimeZoneId;

      this.$refs.regionSelect.updateValue();
      this.$refs.timeZoneSelect.updateValue();
    },
    changedExportCountryCode(keepLanguageCode) {
      let languageList = [];
      if (this.countryLanguages[0]) {
        let cc = this.locationData.LocationExportDefaultCountryCode;
        if (cc) {
          let cl = this.countryLanguages.filter(
            (country) => country.CountryCode === cc
          );
          if (cl[0] && cl[0].Languages) languageList = cl[0].Languages;
        }
      }
      this.currentExportLanguages = languageList;
      if (!keepLanguageCode)
        delete this.locationData.LocationExportDefaultLanguageCode;

      this.$refs.exportLanguageSelect.updateValue();
    },
    sortCustomPropertiesByPosition() {
      if (!this.locationData.CustomProperties) return;

      this.locationData.CustomProperties.sort((a, b) => {
        return a.Position - b.Position;
      });
    },
    locationDataReceived() {
      this.openModal();

      if ($("#collapseCustProp").attr("aria-expanded")) {
        $("#locationManagementEditModal").off(
          "shown.bs.modal",
          this.correctTextareaHeight
        );
        $("#locationManagementEditModal").on(
          "shown.bs.modal",
          this.correctTextareaHeight
        );
      }
      $("#collapseCustProp").off(
        "shown.bs.collapse",
        this.correctTextareaHeight
      );
      $("#collapseCustProp").on(
        "shown.bs.collapse",
        this.correctTextareaHeight
      );
    },
    initLocationData() {
      if (this.selectedLocation < 1) {
        this.dialogTitle = this.lang.L0075;
        this.locationData = {
          LocationStatusId: "A",
        };
        if (this.audiClientId) {
          this.locationData.ClientId = this.audiClientId;
          this.getLocationProperties(this.audiClientId);
        }

        this.changedCountry("");
        this.currentExportLanguages = [];
        this.openModal();
      } else {
        this.dialogTitle = this.lang.L0076;
        this.locationData = {};
        this.currentExportLanguages = [];

        $.ajax({
          method: "GET",
          url: `api/Locations/${this.selectedLocation}`,
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            this.locationDataReceived();
            if (data.Importers) {
              data.ImporterGuid = data.Importers[0].ImporterGuid;
              delete data.Importers;
            }
            this.locationData = data;
            this.changedCountry(this.locationData.LocationCountry);
            this.changedExportCountryCode(true);
            this.sortCustomPropertiesByPosition();
          },
          error: () => {
            console.error("Location data access failed in initLocationData()");
            this.globals.showErrorSnackbar("Location data access failed");
          },
        });
      }
      this.showAlert = false;
      this.resetValidationErrors("locationManagementEditModal");
    },
    saveLocationData() {
      if (this.clientList.length < 1) {
        this.globals.showErrorSnackbar("No client available");
        return;
      }
      let sendData = _.cloneDeep(this.locationData);
      if (sendData.ImporterGuid) {
        sendData.Importers = [{ ImporterGuid: sendData.ImporterGuid }];
        delete sendData.ImporterGuid;

        if (!sendData.ClientId) sendData.ClientId = this.clientList[0].ClientId;
      }

      for (let prop in sendData) {
        if (typeof sendData[prop] === "string" && !sendData[prop])
          delete sendData[prop];
      }

      if (this.selectedLocation < 1) {
        $.ajax({
          method: "POST",
          url: "api/Locations",
          data: JSON.stringify(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            this.globals.showSuccessSnackbar("Location creation successful");
            this.closeModal();
            this.$emit("locationDataUpdated", data[0].LocationId);
          },
          error: () => {
            console.error("Error on POST in saveLocationData()");
            this.globals.showErrorSnackbar("Location creation failed");
          },
        });
      } else {
        $.ajax({
          method: "PUT",
          url: `api/Locations/${this.locationData.LocationId}`,
          data: JSON.stringify(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            this.globals.showSuccessSnackbar("Location update successful");
            this.closeModal();
            this.$emit("locationDataUpdated");
          },
          error: () => {
            console.error("Error on PUT in saveLocationData()");
            this.globals.showErrorSnackbar("Location update failed");
          },
        });
      }
    },
    getSelectData() {
      if (this.globals.selectedLanguage) {
        this.globals.getCountryList();
        this.getLocationStatusList();
      }
      this.globals.getCountryLanguageList((callbackData) => {
        this.countryLanguages = callbackData;
      });
      this.getClientList(() => {
        if (this.feature.isAudiTarget && this.clientList[0]) {
          this.audiClientId = this.clientList[0].ClientId;
        }
      });
      if (
        this.feature.isAudiTarget &&
        this.feature.isEnabled("audi_importers")
      ) {
        this.globals.getImporterList((callbackData) => {
          this.importerList = _.cloneDeep(callbackData);
          _.remove(
            this.importerList,
            (importer) =>
              importer.ImporterGuid === "1D86A788-07D6-4681-BD8C-9C15800DF8BA"
          );
        });
      }
      this.globals.getRegionsList((callbackData) => {
        this.regionList = callbackData;
      });
      this.globals.getTimezonesList((callbackData) => {
        this.timeZones = callbackData;
      });
    },
    getClientList(callback) {
      $.ajax({
        method: "GET",
        url: "api/Data/Clients",
        success: (data) => {
          this.clientList = [];
          for (let x in data) {
            this.clientList.push({ ClientId: x, ClientName: data[x] });
          }

          this.clientList.sort((a, b) => {
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase())
              return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase())
              return 1;
            return 0;
          });

          if (callback) callback();
        },
        error: () => {
          console.error("Client data access failed in getClientList()");
          this.globals.showErrorSnackbar("Client data access failed");
        },
      });
    },
    getLocationStatusList() {
      $.ajax({
        method: "GET",
        url: "api/data/locationstatusses",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.locationStatusList = data;
        },
        error: () => {
          console.error(
            "Location status data access failed in getLocationStatusList()"
          );
          this.globals.showErrorSnackbar("Location status data access failed");
        },
      });
    },
    getLocationProperties(clientId) {
      if (!clientId) return;

      $.ajax({
        method: "GET",
        url: `/api/Clients/${clientId}/LocationProperties`,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.locationData.CustomProperties = data;
          this.sortCustomPropertiesByPosition();
          this.$forceUpdate();
        },
        error: () => {
          console.error(
            "Location properties data access failed in getLocationProperties()"
          );
          this.globals.showErrorSnackbar(
            "Location properties data access failed"
          );
        },
      });
    },
  },
};
</script>

<style scoped>
.textarea-custom-properties {
  display: block;
  overflow: hidden;
  margin: 0;
}

#showLocationHistoryInfoIcon {
  position: relative;
  left: 10px;
  margin: -5px;
  vertical-align: middle;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// LocationManagementEditModal.vue?41d06e0e